<template>
  <b-modal
    :active="isModalActive"
    @update:active="updateModalActive"
    has-modal-card
    trap-focus
    :destroy-on-hide="true"
    aria-role="dialog"
    aria-modal
    :width="640"
    @keydown.stop
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Move Details</p>
        <button class="delete" @click="close" aria-label="close"></button>
      </header>

      <section class="modal-card-body">
        <!-- NAG Section -->
        <b-field label="Quick Annotation">
          <b-field>
            <b-radio-button
              v-for="nag in COMMON_NAGS"
              :key="nag"
              v-model="editedNag"
              :native-value="nag"
              :type="isSelectedNag(nag) ? 'is-primary' : 'is-light'"
              :title="NAG_MAP[nag]"
              @click.native="toggleNag(nag)"
            >
              {{ nag }}
            </b-radio-button>
          </b-field>
        </b-field>

        <b-field label="All Annotations" class="mt-4">
          <b-select
            v-model="editedNag"
            placeholder="Select annotation"
            expanded
          >
            <option value="">None</option>
            <optgroup
              v-for="(group, label) in NAG_GROUPS"
              :key="label"
              :label="label"
            >
              <option v-for="nag in group" :key="nag" :value="nag">
                {{ nag }} ({{ NAG_MAP[nag] }})
              </option>
            </optgroup>
          </b-select>
        </b-field>

        <!-- Comment Section -->
        <b-field label="Comment" class="mt-4">
          <b-input
            v-model="editedComment"
            type="textarea"
            placeholder="Add a comment..."
            :rows="3"
            custom-class="comment-textarea"
          ></b-input>
        </b-field>
      </section>

      <footer class="modal-card-foot">
        <b-button type="is-primary" @click="save" :disabled="!hasChanges">
          Save Changes
        </b-button>
        <b-button @click="close">Cancel</b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import {
  COMMON_NAGS,
  NAG_VALUES,
  NAG_MAP,
  NAG_GROUPS,
} from "vue-chess-shared/pgn/Nag";

export default {
  name: "MoveAnnotationEdit",

  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    comment: {
      type: String,
      default: null,
    },
    nag: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      editedComment: "",
      editedNag: "",
      NAG_VALUES,
      NAG_MAP,
      COMMON_NAGS,
      NAG_GROUPS,
    };
  },

  computed: {
    isModalActive: {
      get() {
        return this.isActive;
      },
      set(value) {
        this.$emit("update:isActive", value);
      },
    },

    hasChanges() {
      return (
        this.editedComment !== (this.comment || "") ||
        this.editedNag !== (this.nag || "")
      );
    },
  },

  watch: {
    isActive(newValue) {
      if (newValue) {
        this.editedComment = this.comment || "";
        this.editedNag = this.nag || "";
      }
    },
  },

  methods: {
    updateModalActive(value) {
      if (!value) {
        this.close();
      }
    },

    isSelectedNag(nag) {
      return this.editedNag === nag;
    },

    toggleNag(nag) {
      this.editedNag = this.editedNag === nag ? "" : nag;
    },

    close() {
      if (this.hasChanges) {
        this.$buefy.dialog.confirm({
          title: "Unsaved Changes",
          message: "Are you sure you want to discard your changes?",
          confirmText: "Discard",
          cancelText: "Keep Editing",
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.$emit("close"),
        });
      } else {
        this.$emit("close");
      }
    },

    save() {
      this.$emit("save", {
        comment: this.editedComment.trim() || null,
        nag: this.editedNag || null,
      });
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.comment-textarea {
  resize: vertical;
}
</style>
